import { forEach } from 'lodash-es'

export default {
    methods: {
        /**
         * Translate the given key.
         */
        __(key, replace){
            const getTranslation = function(key) {
                if (! window.translations) return key
                return window.translations[key] ? window.translations[key] : key
            }

            let translation = getTranslation(key)

            forEach(replace, (value, key) => {
                translation = translation.replace(':'+key, value)
            })

            return translation
        },
    }
}
